import React, { useRef } from 'react';
import VideoIcon from '../../../../assets/svgs/video.svg';

const VimeoButton = ({ buttonClassName, buttonText, showIcon, onPlay }) => {
  const videoPlayButtonRef = useRef();

  return (
    <button className={buttonClassName} ref={videoPlayButtonRef} onClick={onPlay}>
      {showIcon && <VideoIcon />} {buttonText}
    </button>
  );
};

export default VimeoButton;
